import styled from "styled-components/macro";

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: center;
  transition: 0.5s;
  & > div > div > img {
    height: 100px;
    width: 100px;
    margin-right: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  & hr {
    margin: 1em 0;
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${(props) => props.theme.colors.border};
  }
  & .buttonGroup {
    @media ${(props) => props.theme.media.phone} {
      width: 100%;
      & > button:first-child {
        margin-bottom: 8px;
      }
      & button {
        width: 100%;
      }
    }
  }
`;

export const DivBlock = styled.div`
  display: inline-block;
  & > h4:first-child {
    margin-bottom: 8px;
  }
`;

export const ButtonsDiv = styled.div`
  display: grid;
  justify-content: end;
  align-items: center;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, 180px);
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
`;
